import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e36d1070"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cashback-progress-wrapper mb-4 p-4" }
const _hoisted_2 = { class: "wallet-amount-text mb-2" }
const _hoisted_3 = ["alt"]
const _hoisted_4 = { class: "heading-2" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = {
  key: 0,
  class: "header-buttons"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col col-6" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "col col-6 d-flex justify-content-end" }
const _hoisted_11 = ["alt"]
const _hoisted_12 = { class: "wallet-amount-small" }
const _hoisted_13 = {
  key: 0,
  class: "reward-wrapper pb-4"
}
const _hoisted_14 = { class: "reward-name" }
const _hoisted_15 = { class: "reward-price" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "reward-wrapper pb-4"
}
const _hoisted_18 = { class: "reward-name" }
const _hoisted_19 = { class: "reward-price" }
const _hoisted_20 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_CircularProgress = _resolveComponent("CircularProgress")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("img", {
          alt: _ctx.vm.icon.alt,
          class: "wallet-icon"
        }, null, 8, _hoisted_3), [
          [_directive_lazy, _ctx.vm.icon.url]
        ]),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.vm.headerTitle), 1)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.vm.headerSubtitle), 1),
      (_ctx.vm.headerButtonLinks && _ctx.vm.headerButtonLinks.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.headerButtonLinks, (link, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createVNode(_component_Button, {
                  class: _normalizeClass(index === 0
                        ? 'p-button p-component p-button-success p-button-raised p-button-arrow p-button-lg'
                        : 'p-button p-component p-button-link p-button-lg p-button-primary'),
                  onClick: ($event: any) => (_ctx.openUrl(link.url)),
                  label: link.text
                }, null, 8, ["class", "onClick", "label"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.vm.pageTitle), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("img", {
          alt: _ctx.vm.icon.alt,
          class: "wallet-icon-small"
        }, null, 8, _hoisted_11), [
          [_directive_lazy, _ctx.vm.icon.url]
        ]),
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.formatCurrency(_ctx.vm.totalAutodeskSaved)), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mappedProds, (product) => {
        return (_openBlock(), _createElementBlock("div", {
          key: product,
          class: "col col-12 col-sm-6 col-lg-4"
        }, [
          (product.cashback && product.cashbackText && product.price && product.priceText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_CircularProgress, { item: product }, null, 8, ["item"]),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.formatCurrency(product.cashback)) + " " + _toDisplayString(product.cashbackText), 1),
                _createElementVNode("div", _hoisted_15, [
                  (product.price)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(product.priceText) + " " + _toDisplayString(_ctx.formatCurrency(product.price)), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_Button, {
                  class: "p-button-success p-button-sm",
                  label: product.buttonLink.text,
                  onClick: ($event: any) => (_ctx.openCashbackForm(product)),
                  disabled: _ctx.vm.totalAutodeskSaved < product.price
                }, null, 8, ["label", "onClick", "disabled"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_CircularProgress, { item: product }, null, 8, ["item"]),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.formatProductName(product.name, product.brand)), 1),
                _createElementVNode("div", _hoisted_19, [
                  (product.price)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.$t('myCadac.myrewards.tile.priceText')) + " " + _toDisplayString(_ctx.formatCurrency(product.price)), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_Button, {
                  class: "p-button-success p-button-sm",
                  label: _ctx.$t('myCadac.myrewards.button.label'),
                  onClick: ($event: any) => (_ctx.openUrl(product.productPageUrl))
                }, null, 8, ["label", "onClick"])
              ]))
        ]))
      }), 128))
    ])
  ], 64))
}